import "./App.css";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "dayjs/locale/zh-cn";
import Layout from "./Layout";
import SignIn from "./SignIn";
import PulseDiagnosis from "./module.pulse_diagnosis";
import Guide from "./module.pulse_diagnosis/guide/Guide";
import User from "./module.pulse_diagnosis/user/User";
import PopupFeedback from "./module.pulse_diagnosis/popupFeedback/PopupFeedback";
import Feedback from "./module.pulse_diagnosis/feedback/Feedback";
import ResultFeedback from "./module.pulse_diagnosis/resultFeedback/ResultFeedback";
import FeedbackManagement from "./module.pulse_diagnosis/feedbackManagement/FeedbackManagement";
import UserAgreement from "./module.pulse_diagnosis/user/UserAgreement";
import Operator from "./module.operator";
import UserList from "./module.operator/user/User";
import Role from "./module.operator/role/Role";
import Menu from "./module.operator/menu/Menu";
import AiInfo from "./module.pulse_diagnosis/ai/AiInfo";
import TongueConf from "./module.pulse_diagnosis/ai/TongueConf";
import MemberOrder from "./module.pulse_diagnosis/memberOrder/MemberOrder";
import VIPPackage from "./module.pulse_diagnosis/vipPackage/VIPPackage";
import RefundRecord from "./module.pulse_diagnosis/refundRecord/RefundRecord";
import Health from "./module.pulse_diagnosis/health/Health";
import HealthTemp from "./module.pulse_diagnosis/health/HealthTemp";
import HealthFeedback from "./module.pulse_diagnosis/popupFeedback/HealthFeedback";
import HealthConsultationConfig from "./module.pulse_diagnosis/healthConsultation/HealthConsultationConfig";

const router = createBrowserRouter([
    {
        path: "/sign_in",
        element: <SignIn />,
    },
    {
        path: "/",
        element: <Layout />,
        children: [
            {
                path: "/pulse-diagnosis",
                element: <PulseDiagnosis />,
                children: [
                    {
                        path: "/pulse-diagnosis/guide",
                        element: <Guide />,
                    },
                    {
                        path: "/pulse-diagnosis/user",
                        element: <User />,
                    },
                    {
                        path: "/pulse-diagnosis/popup-feedback",
                        element: <PopupFeedback />,
                    },
                    {
                        path: "/pulse-diagnosis/feedback",
                        element: <Feedback />,
                    },
                    {
                        path: "/pulse-diagnosis/result-feedback",
                        element: <ResultFeedback />,
                    },
                    {
                        path: "/pulse-diagnosis/feedback-management",
                        element: <FeedbackManagement />,
                    },
                    {
                        path: "/pulse-diagnosis/user-agreement",
                        element: <UserAgreement />,
                    },
                    {
                        path: "/pulse-diagnosis/ai-info",
                        element: <AiInfo />,
                    },
                    {
                        path: "/pulse-diagnosis/tongue-conf",
                        element: <TongueConf />,
                    },
                    {
                        path: "/pulse-diagnosis/member-order",
                        element: <MemberOrder />,
                    },
                    {
                        path: "/pulse-diagnosis/vip-package",
                        element: <VIPPackage />,
                    },
                    {
                        path: "/pulse-diagnosis/refund-record",
                        element: <RefundRecord />,
                    },
                    {
                        path: "/pulse-diagnosis/health",
                        element: <Health />,
                    },
                    {
                        path: "/pulse-diagnosis/health/temp/:id",
                        element: <HealthTemp />,
                    },
                    {
                        path: "/pulse-diagnosis/health-feedback",
                        element: <HealthFeedback />,
                    },
                    {
                        path: "/pulse-diagnosis/health-consultation-config",
                        element: <HealthConsultationConfig />,
                    },
                ],
            },
            {
                path: "/operator",
                element: <Operator />,
                children: [
                    {
                        path: "/operator/user",
                        element: <UserList />,
                    },
                    {
                        path: "/operator/role",
                        element: <Role />,
                    },
                    {
                        path: "/operator/menu",
                        element: <Menu />,
                    },
                ],
            },
        ],
    },
    {
        path: "*",
        element: <SignIn />,
    },
]);

function App() {
    return <RouterProvider router={router} />;
}

export default App;
